<template>
  <form
    class="default_form position-relative"
    v-bind="form_attributes"
    :class="{white_form: white_form}"
    @submit.prevent="submit">
    <div
      v-if="add_submit_button"
      @click="goBack"
      class="default_form__back-btn mb-10">
      <chevron-left-icon
        class="mr-5"
        fill="#000"/>
      <b>{{$t('btn.back')}}</b>
    </div>
    <slot></slot>
    <info-block
      class="mt-15"
      v-if="!!error_text"
      :text="error_text"
    />
    <loader v-if="fetching"/>
  </form>
</template>

<script>

import ChevronLeftIcon from "../../icons/ChevronLeftIcon";
import component_fetcher from "../../../mixins/component_fetcher";
import InfoBlock from "../InfoBlock";
import Loader from "../Loader";
import {SCROLL_INTO_VIEW, validateForm} from "../../../mixins/input_validations";

export default {
  name: "DefaultForm",
  components: {
    Loader,
    InfoBlock,
    ChevronLeftIcon,
  },
  mixins: [component_fetcher],
  props: {
    form_id: {
      type: String,
      default: ''
    },
    close_route_name: {
      type: String,
      default: ''
    },
    add_submit_button: {
      type: Boolean,
      default: false
    },
    hidden_submit_button_new: {
      type: Boolean,
      default: false
    },
    error_text: {
      type: String,
      default: ''
    },
    success_text: {
      type: String,
      default: ''
    },
    submit_f: {
      type: [Function, Boolean],
      default: false
    },
    fetching: {
      type: Boolean,
      default: false
    },
    white_form: {
      type: Boolean,
      default: false
    },
    focus_on_error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    form_attributes() {
      if(!this.form_id) return null
      return {
        id: this.form_id
      }
    },
  },
  methods: {
    submit(e) {
      if (typeof this.submit_f == 'function') {
        return this.submit_f(e)
      }
      return this.defaultSubmitF(e)
    },
    defaultSubmitF(e) {
      let focused_on_error = false
      let components = validateForm(this.$el)
      setTimeout(() => { // add interval to mutate components
        if (components.every((vue_el) => {
          if (!vue_el.is_valid && this.focus_on_error && vue_el.$el) {
            this.focusOnEl(vue_el.$el, focused_on_error)
            focused_on_error = true
            return false
          }
          return vue_el.is_valid
        })){
          this.$emit('submit', e)
        }
      }, 0)
    },
    focusOnEl(el, focused) {
      if (focused) return
      SCROLL_INTO_VIEW(el)

      return;
      let accordion_el = el.closest('.accordion__item-slide')
      if (!accordion_el || accordion_el.classList.contains('active')) {
        SCROLL_INTO_VIEW(el)
        return;
      }
      let accordion_el_index = Number(accordion_el.dataset.index)
      let accordion = accordion_el.closest('.accordion')
      if (!accordion || isNaN(accordion_el_index) || !accordion.__vue__) return;
      accordion.__vue__.changeIndexOpened(accordion_el_index)
      setTimeout(()=> {
        SCROLL_INTO_VIEW(el)
      }, 300)
    },
    goBack() {
      if (!this.close_route_name) {
        this.$router.back()
        return
      }
      this.$router.push({name: this.close_route_name})
    }
  }
}
</script>
